import { useEffect, useState } from "react";
import api from "@/lib/api";

let _config = null;
let _loading = null;
const listeners = new Set();

function runScripts(container) {
  container.querySelectorAll("script").forEach((old) => {
    const s = document.createElement("script");
    [...old.attributes].forEach((a) => s.setAttribute(a.name, a.value));
    s.text = old.text;
    document.head.appendChild(s);
  });
}

// Pixel ID from the ID field, or pulled out of a pasted Meta snippet (fbq('init', '123...'))
export function extractPixelId(mp) {
  const direct = String(mp?.pixel_id || "").replace(/\D/g, "");
  if (direct.length >= 6) return direct;
  const m = String(mp?.custom_head_code || "").match(/fbq\(\s*['"]init['"]\s*,\s*['"]?(\d{6,20})/);
  return m ? m[1] : "";
}

function loadFbq() {
  /* eslint-disable */
  !(function (f, b, e, v, n, t, s) {
    if (f.fbq) return; n = f.fbq = function () { n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments); };
    if (!f._fbq) f._fbq = n; n.push = n; n.loaded = !0; n.version = "2.0"; n.queue = [];
    t = b.createElement(e); t.async = !0; t.src = v; s = b.getElementsByTagName(e)[0]; s.parentNode.insertBefore(t, s);
  })(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");
  /* eslint-enable */
}

function injectPixel(mp) {
  if (window.__pzPixelDone) return;
  window.__pzPixelDone = true;
  const id = extractPixelId(mp);
  if (id) {
    loadFbq();
    window.fbq("init", id);
    window.fbq("track", "PageView");
    window.__pzPixelId = id;
    return;
  }
  const custom = (mp.custom_head_code || "").trim();
  if (custom) {
    const wrap = document.createElement("div");
    wrap.innerHTML = custom;
    [...wrap.childNodes].forEach((n) => { if (n.nodeType === 1 && n.tagName !== "SCRIPT") document.head.appendChild(n.cloneNode(true)); });
    runScripts(wrap);
  }
}

function pixelActive() {
  return !!(_config?.meta_pixel?.enabled && window.fbq);
}

export function loadSiteConfig() {
  if (_loading) return _loading;
  _loading = api.get("/config/public").then(({ data }) => {
    _config = data;
    if (data?.meta_pixel?.enabled) injectPixel(data.meta_pixel);
    listeners.forEach((l) => l(data));
    return _config;
  }).catch(() => { _loading = null; return _config; });
  return _loading;
}

export function getSiteConfig() { return _config; }

export function trackPageView() {
  if (pixelActive()) { try { window.fbq("track", "PageView"); } catch (e) { /* ignore */ } }
}

export function fbTrackStandard(event, params, opts) {
  if (pixelActive()) { try { window.fbq("track", event, params || {}, opts || {}); } catch (e) { /* ignore */ } }
}

// Fire a Meta Pixel event mapped from an app trigger (register/deposit/game_play/win)
export function fbTrack(triggerKey, params, opts) {
  const ev = _config?.meta_pixel?.events?.[triggerKey];
  if (ev) fbTrackStandard(ev, params, opts);
}

let _syncing = false;
// Fire Purchase once per deposit that was actually received (MXPay success or admin approval)
export async function syncPixelConversions() {
  if (_syncing || !localStorage.getItem("pazer_token")) return;
  _syncing = true;
  try {
    await loadSiteConfig();
    if (!pixelActive() || !_config?.meta_pixel?.events?.deposit) return;
    const { data } = await api.get("/wallet/pixel-conversions");
    if (!data?.length) return;
    data.forEach((c) => fbTrack("deposit", { value: c.value, currency: "INR" }, { eventID: c.ref }));
    await api.post("/wallet/pixel-conversions/ack", { refs: data.map((c) => c.ref) });
  } catch (e) { /* ignore */ } finally { _syncing = false; }
}

export function useSiteConfig() {
  const [cfg, setCfg] = useState(_config);
  useEffect(() => {
    listeners.add(setCfg);
    if (!_config) loadSiteConfig();
    else setCfg(_config);
    return () => listeners.delete(setCfg);
  }, []);
  return cfg;
}
